import { useEffect } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { usePlayerState } from './usePlayerState';

export function useNoPlayback(enabled: boolean = true) {
  const player = usePlayer();
  const playbackState = usePlayerState();

  useEffect(
    function preventPlayback() {
      if (enabled && playbackState === 'playing') {
        player.pause();
      }
    },
    [enabled, player, playbackState]
  );
}
